import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import StateDetail from './components/StateDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageState',
  components: {
    StateDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;